import axiosInstance from 'services/axios/axios';
import { then } from 'services/axios/_utility';
import { WrapImsPacket } from 'store/utility';
import { prepareIdentifierSpecifier } from './_util';

export const searchThirdPartyOrganizations = async (queryParam, dispatch) => {
	return await axiosInstance
		.get('api/Agreements/ThirdPartyOrganizations/Search', {
			params: {
				value: queryParam,
			},
		})
		.then(response => then(response, payload => payload, dispatch))
		.catch(ex => {
			throw ex;
		});
};

export const searchNonEmployeeJobTitles = async (queryParam, dispatch) => {
	return await axiosInstance
		.get('api/ESO/NonEmployee/NonEmployeeJobTitles/Search', {
			params: {
				value: queryParam,
			},
		})
		.then(response => then(response, payload => payload, dispatch))
		.catch(ex => {
			throw ex;
		});
};

export const fetchStateList = async dispatch => {
	return await axiosInstance
		.get('api/ESO/NonEmployee/Identifiers/States')
		.then(response => then(response, payload => payload, dispatch))
		.catch(ex => {
			throw ex;
		});
};

export const fetchPartners = async dispatch => {
	return await axiosInstance
		.get('api/ESO/NonEmployee/Identifiers/Partners')
		.then(response => then(response, payload => payload, dispatch))
		.catch(ex => {
			throw ex;
		});
};

export const fetchUniversityList = async dispatch => {
	return await axiosInstance
		.get('api/ESO/NonEmployee/Identifiers/Universities')
		.then(response => then(response, payload => payload, dispatch))
		.catch(ex => {
			throw ex;
		});
};

export const submitEpicCareLinkUserCreation = async values => {
	return axiosInstance
		.post('/api/ESO/NonEmployee/EpicCareLinkUser', WrapImsPacket(values))
		.then(response => {
			return response;
		})
		.catch(error => {
			throw error;
		});
};
export const checkIfEpicCareLinkSiteIsProcessed = async id => {
	return axiosInstance
		.post('api/ESO/NonEmployee/EpicCareLink/IsProcessed/' + id)
		.then(response => {
			return response;
		})
		.catch(error => {
			throw error;
		});
};

export const checkIfEpicCareLinkIsDeclined = async (id, sponsorEmail) => {
	return axiosInstance
		.post('api/ESO/NonEmployee/EpicCareLink/IsDeclined/', {
			messageId: id,
			sponsorEmail: sponsorEmail
		})
		.then(response => {
			return response;
		})
		.catch(error => {
			throw error;
		});
};

export const submitAutomationEpicCareLinkUserCreation = async (
	eventID,
	values
) => {
	return axiosInstance
		.post(
			'/api/ESO/NonEmployee/AutomateEpicCareLinkUser/' + eventID,
			WrapImsPacket(values)
		)
		.then(response => {
			return response;
		})
		.catch(error => {
			throw error;
		});
};

export const declineEpicCareLinkUserCreation = async (
	fMessageId,
	sponsorEmail,
	declineReason,
	userIdentity
) => {
	return axiosInstance
		.post('/api/ESO/NonEmployee/DeclineEpicCareLinkUserCreation/', {
			fMessageId: fMessageId,
			sponsorEmail: sponsorEmail,
			declineReason: declineReason,
			userIdentity: userIdentity,
		})
		.then(response => {
			return response;
		})
		.catch(error => {
			throw error;
		});
};

export const submitCommunityConnectUserCreation = async values => {
	return axiosInstance
		.post(
			'/api/ESO/NonEmployee/CommunityConnectUser',
			WrapImsPacket(values)
		)
		.then(response => {
			return response;
		})
		.catch(error => {
			throw error;
		});
};

export const checkForExistingIdentifier = async (
	identifierNumber,
	identifierType,
	identifierSpecifier,
	lastName = null,
	dob = null,
	loggedInUser = null
) => {
	//special accommodation for drivers license where specifier is an object instead of typical string
	const preparedIdentifierSpecifier = prepareIdentifierSpecifier(
		identifierSpecifier,
		identifierType
	);

	return axiosInstance
		.post(
			'/api/ESO/NonEmployee/Identifiers/Check',
			WrapImsPacket({
				number: identifierNumber,
				type: identifierType,
				specifier: preparedIdentifierSpecifier,
				creator: loggedInUser,
				lastName: lastName,
				dob: dob,
			})
		)
		.then(response => then(response, payload => payload))
		.catch(error => {
			throw error;
		});
};

export const checkForExistingEmail = async email => {
	return axiosInstance
		.post('/api/ESO/NonEmployee/Email/Check/', WrapImsPacket(email))
		.then(response => response.data)
		.catch(error => {
			throw error;
		});
};

export const fetchSiteAdminModelPrerequisiteCheck = async (id, selfSponsor) => {
	const url = selfSponsor
		? 'PrerequisiteCheckSelfSponsor/'
		: 'PrerequisiteCheck/';
	return await axiosInstance
		.get('api/ESO/NonEmployee/EpicCareLinkUser/' + url + id, {
			selfSponsor: selfSponsor,
		})
		.then(response => response.data)
		.catch(ex => {
			throw ex;
		});
};

export const fetchPageRoles = async route => {
	return axiosInstance
		.post('/api/Menu/Roles', WrapImsPacket(route))
		.then(response => response.data)
		.catch(error => {
			throw error;
		});
};
